<ngx-loading-bar color="black"></ngx-loading-bar>
<app-header></app-header>
<app-tab-bar></app-tab-bar>
<div class="container">
  <router-outlet></router-outlet>
</div>
<span id="session-timeout-modal-label" class="d-none">{{ 'aria.session-expire-dialog' | translate }}</span>
<app-footer></app-footer>
